import { render, staticRenderFns } from "./AtomFileInput.vue?vue&type=template&id=3388def5&scoped=true&"
import script from "./AtomFileInput.vue?vue&type=script&lang=js&"
export * from "./AtomFileInput.vue?vue&type=script&lang=js&"
import style0 from "./AtomFileInput.vue?vue&type=style&index=0&id=3388def5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388def5",
  null
  
)

export default component.exports